import React, { PureComponent } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col, Panel } from 'react-bootstrap';
import { isEmptyString } from '../../validators/formValidators';
import { getPaymentAccount, getDateTimeFromUtcInLocalTime, isEvenPartOfInvoice } from '../../helpers/utils';
import Select from './Select';
import Button from './Button';
import TextArea from './TextArea';
import MinutesInput from './MinutesInput';
import DateInput from './DateInput';
import CashInput from './CashInput';
import ItemsForm from './ItemsForm';
import TextInput from './TextInput';
import CheckBox from './CheckBox';
import { DEFAULT_BILLABLE_MINUTE_INCREMENTS } from '../PaymentForm';
import NumberInput from './NumberInput';
        

export const validateField = (field) => {
    field = { ...field };
    if (field.error) {
        delete field.error['items'];
        delete field.error['amount'];
        delete field.error['Amount'];
        delete field.error['EventDate'];
        delete field.error['EventDescription'];
    }

    if (field['EventType'] === 'Charge') {
        if (isEmptyString(field['amount'])) {
            if (!field.error) {
                field.error = {};
            }

            field.error['amount'] = 'Cannot be empty';
            field.error['Amount'] = 'Cannot be empty';

        } else if (isNaN(parseFloat(field['amount']))) {
            if (!field.error) {
                field.error = {};
            }

            field.error['amount'] = 'Invalid number';
            field.error['Amount'] = 'Invalid number';
        }
    }

    delete field['$EventDescription$'];
    delete field['$EventEditAction$'];
    return field;
}         

class EventForm extends PureComponent {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.state = {
            field: {},
            minutesInputState: "STOPPED"
        };
    }

    componentDidMount() {
        this.componentWillReceiveProps(this.props);
    }

    componentWillReceiveProps(nextProps) {
        const field = {...nextProps.initialField};
        if (field['amount'] && field['amount'] < 0) {
            field['amount'] = Math.abs(field['amount']);
            field['EventType'] = 'ChargeRefund';
        }
        this.setState({field});
    }

    onChange(evt) {
        const fieldName = evt.target.name;
        let value = evt.target.value;
        let field = this.state.field;
        switch (fieldName) {
        case 'EventDescription':
            field['EventDescription'] = value;
            if (field.error) {
                delete field.error['EventDescription'];
            }

            if (value.length >= 500) {
                if (!field.error) {
                    field.error = {};
                }

                field.error['EventDescription'] = 'Too long (500 characters max).';
            }

            break;

        case 'EventType':
            if (value == 'ChargeRefund') {
                delete field['$TrustAccountTransfer$'];
            }
            field[fieldName] = value;
            break;

        default:
            field[fieldName] = value;
            break;
        }

        if (this.props.onChange) {
            this.props.onChange(field);
        }
    }

    render() {
        const {
            label,
            actionLabel,
            onActionBtnClicked,
            disableEventTypeEditing = false,
            defaultHourlyRate,
            allowTrustAccountTransfer
        } = this.props;

        let field = this.state.field;
        const disabled = this.props.disabled || isEvenPartOfInvoice(field);
        let details = (
            <div>
                <Row>
                    <Col xs={12}>
                        <Select field={{
                                    name: 'EventType',
                                    error: field.error ? field.error['EventType'] : undefined,
                                    touched: true,
                                    value: field['EventType'],
                                    onChange: this.onChange
                                }}
                                label='Type'
                                name='EventType'
                                disabled={disabled || disableEventTypeEditing}
                                options={[
                                    {label: 'Note', value: 'Note'},
                                    {label: 'Payment', value: 'Charge'},
                                    {label: 'Payment Refund', value: 'ChargeRefund'},
                                    {label: 'Cost', value: 'Cost'},
                                    {label: 'Contacted', value: 'Contacted'},
                                    {label: 'Time', value: 'Time'},
                                ]}
                                onChange={this.onChange}
                        />
                    </Col>
                </Row>
                {this.props.showDateTime && (
                <Row>
                    <Col xs={12} style={{zIndex: 10}}>
                        <DateInput field={{
                                        name: 'EventDate',
                                        touched: true,
                                        error: field.error ? field.error['EventDate'] : undefined,
                                        value: field['EventDate'],
                                        onChange: (date) => {
                                            let d = getDateTimeFromUtcInLocalTime(date, this.props.loggedIn);
                                            this.onChange({target: {name: 'EventDate', value: d}});
                                        }
                                    }}
                                    label='Date'
                                    name='EventDate'
                                    time
                                    disabled={disabled}/>
                    </Col>
                </Row>
                )}
                <Row>
                    <Col xs={12}>
                        <TextArea field={{
                                       name: 'EventDescription',
                                       error: field.error ? field.error['EventDescription'] : undefined,
                                       touched: true,
                                       value: field['EventDescription'],
                                       onChange: this.onChange
                                  }}
                                  disabled={disabled}
                                  label='Description'
                                  name='EventDescription'
                                  help='Description of the event.'
                        />
                    </Col>
                </Row>
                {field['EventType'] === 'Time' && (
                <React.Fragment>
                <Row>
                    <Col xs={12}>
                        <CashInput
                            field={{
                                    name: 'hourlyRate',
                                    error: field.error ? field.error['hourlyRate'] : undefined,
                                    touched: true,
                                    value: field['hourlyRate'] == undefined ? defaultHourlyRate : field['hourlyRate'],
                                    onChange: this.onChange
                            }}
                            disabled={disabled}
                            allowFloat={false}
                            name="hourlyRate"
                            label="Hourly Rate"
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <MinutesInput
                            field={{
                                    name: 'time',
                                    error: field.error ? field.error['time'] : undefined,
                                    touched: true,
                                    value: field['time'],
                                    onChange: this.onChange,
                                    onBlur: (evt) => {
                                        evt.target.value = Math.ceil(evt.target.value / this.props.billingIncrement) * this.props.billingIncrement
                                        this.onChange(evt)
                                    }
                            }}
                            defaultValue={0}
                            disabled={disabled}
                            name="time"
                            label="Time (minutes)"
                            increment={this.props.billingIncrement}
                            onStateChange={minutesInputState => this.setState({minutesInputState})}
                        />
                    </Col>
                </Row>
                </React.Fragment>)}
                {field['EventType'] === 'Charge' && (
                <React.Fragment>
                <Row>
                    <Col xs={12}>
                        <CashInput field={{
                                       name: 'amount',
                                       error: field.error ? field.error['amount'] : undefined,
                                       touched: true,
                                       value: field['amount'],
                                       onChange: this.onChange
                                   }}
                                   disabled={disabled}
                                   label='Amount'
                        />
                    </Col>
                </Row>
                {allowTrustAccountTransfer &&
                <Row>
                    <Col xs={12}>
                        <CheckBox field={{
                                       name: '$TrustAccountTransfer$',
                                       error: field.error ? field.error['$TrustAccountTransfer$'] : undefined,
                                       touched: true,
                                   }}
                                   checked={!!field['$TrustAccountTransfer$']}
                                   onChange={(_elem) => {
                                        this.onChange({target: { name: '$TrustAccountTransfer$', value: !field['$TrustAccountTransfer$']}});
                                   }}
                                   disabled={disabled}
                                   label='Is transfer from trust account?'
                        />
                    </Col>
                </Row>}
                </React.Fragment>)}
                {field['EventType'] === 'ChargeRefund' && (
                    <Row>
                        <Col xs={12}>
                            <CashInput field={{
                                           name: 'amount',
                                           error: field.error ? field.error['amount'] : undefined,
                                           touched: true,
                                           value: field['amount'],
                                           onChange: this.onChange
                                       }}
                                       disabled={disabled}
                                       label='Refund'
                            />
                        </Col>
                    </Row>)}
                {field['EventType'] === 'Cost' && (
                <div>
                    <Row style={{marginLeft: 15}}>
                    <label
                        className="form-group"
                        key={'cost_key'}>Cost Breakdown (Description | Qty | Amount)</label>
                    </Row>
                    <Row style={{marginLeft: 0, marginRight: 15}}>
                    <Col xs={12}>
                        <ItemsForm 
                            items={this.state.field.items}
                            defaultItem={{description: '', amount: '0'}}
                            setItems={items => this.onChange({ target: { name: 'items', value: items }})}
                            renderItem={(selectedIndex, items, disabled_) => {
                                return (
                                    <div onClick={() => this.setState({selectedIndex})}>
                                    <Row>
                                    <Col xs={7}>
                                    <TextInput
                                        field={{
                                            name: 'description',
                                            onChange: evt => {
                                                items[selectedIndex]['description'] = evt.target.value;
                                                this.onChange({ target: { name: 'items', value: items }});
                                            },
                                            value: items[selectedIndex]['description']
                                        }}
                                        disabled={disabled || disabled_}
                                        plainInput
                                    />
                                    </Col>
                                    <Col xs={2}>
                                    <NumberInput
                                        field={{
                                            name: 'qty',
                                            onChange: evt => {
                                                items[selectedIndex]['qty'] = evt.target.value;
                                                this.onChange({ target: { name: 'items', value: items }});
                                            },
                                            value: items[selectedIndex]['qty'] || 1
                                        }}
                                        disabled={disabled}
                                    />
                                    </Col>
                                    <Col xs={3}>
                                    <CashInput
                                        field={{
                                            name: 'amount',
                                            onChange: evt => {
                                                items[selectedIndex]['amount'] = evt.target.value;
                                                this.onChange({ target: { name: 'items', value: items }});
                                            },
                                            value: items[selectedIndex]['amount']
                                        }}
                                        disabled={disabled}
                                        plainInput
                                    />
                                    </Col>
                                    </Row>
                                    </div>);
                            }}
                            disabled={disabled}
                            modificationDisabled={() => false}
                        />
                    </Col>
                    </Row>
                </div>)}
            </div>
        );

        let actionBtn = '';
        if (onActionBtnClicked) {
            actionBtn = (
                <Row style={{float: 'right', marginRight: 0}}>
                <Col xs={12}>
                <Button
                    label={actionLabel}
                    onClick={() => {
                        onActionBtnClicked(field);
                    }}
                    disabled={this.state.minutesInputState == "PLAYING"}
                    bsStyle="primary"
                    style={{width: 150}}
                />
                </Col>
                </Row>
            );
        }

        return (
            <Panel data-hj-whitelist header={label}>
            {details}
            {actionBtn}
            </Panel>
        );
    }
}

EventForm.propTypes = {
    onChange: PropTypes.func.isRequired,
    initialField: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    actionLabel: PropTypes.string,
    onActionBtnClicked: PropTypes.func,
    showDateTime: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => {
    const loggedIn = state.user.loggedIn;
    const currentCase = state.cases.current;
    const defaultHourlyRate = (currentCase && currentCase.payment && currentCase.payment['HourlyRate']) || '';
    const billingIncrement = (currentCase && currentCase.payment && currentCase.payment['BillableMinuteIncrements']) || DEFAULT_BILLABLE_MINUTE_INCREMENTS;
    const {accountType, account} = getPaymentAccount(loggedIn);
    const allowTrustAccountTransfer = accountType == 'LawPay';
    return { loggedIn, currentCase, defaultHourlyRate, billingIncrement, allowTrustAccountTransfer };
};

export default connect(mapStateToProps)(EventForm);
